import gql from 'graphql-tag';

export const FUND_TITLE_QUERY = gql`
    query MutualFundTitle($ticker: String!) {
        mutualFund(ticker: $ticker) {
            name
            shortName
            previousName
            openToNewInvestors
            openToSubsequentInvestments
            iClass
            rClass
            advisorClass
            correspondingFundTicker
            cusip
            trpCode
            selectFund
            assetClassName
            activeMoneyMarketFundMessages {
                message
                messageType
                trpCode
                liquidityFeePercent
                eventPeriodType
            }
            price {
                price
                asOfDate
            }
        }
    }
`;

export const ETF_TITLE_QUERY = gql`
    query ETFTitle($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            name
            shortName
            exchange
            publicOfferingDate
            cusip
            trpCode
            price {
                price: navPrice
                closingPrice
                asOfDate
                outstandingShares
                dailyTradingVolumeShares: dailyVolume
            }
        }
    }
`;
